import React, { useEffect, useRef, useState } from 'react';
import { MapData } from '../../../types/map';
import PlaceVisitHistory from '../PlaceVisitHistory';
import './PlaceSheet.css';

export default function PlaceSheet({ place, isLoggedIn, canEdit, onClose, onManage }: {
  place: MapData; isLoggedIn: boolean; canEdit: boolean;
  onClose: () => void; onManage: () => void;
}) {
  const closeButton = useRef<HTMLButtonElement>(null);
  const sheet = useRef<HTMLElement>(null);
  const close = useRef(onClose);
  close.current = onClose;
  const [failedPhotos, setFailedPhotos] = useState<string[]>([]);
  const photos = Array.from(new Set([place.urlSource, place.url].filter((url): url is string =>
    !!url && /^https:\/\//.test(url) && !url.includes('placeholder'))));
  const photo = photos.find(url => !failedPhotos.includes(url));
  const photoFailed = photos.length > 0 && !photo;
  useEffect(() => { setFailedPhotos([]); }, [place.id, place.urlSource, place.url]);
  useEffect(() => {
    const previous = document.activeElement as HTMLElement;
    closeButton.current?.focus({ preventScroll: true });
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && sheet.current?.contains(document.activeElement)) close.current();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      if (previous?.isConnected) previous.focus({ preventScroll: true });
    };
  }, [place.id]);

  return <section ref={sheet} className="place-sheet" aria-labelledby="place-sheet-name">
    <div className="place-sheet__handle" aria-hidden="true" />
    <header className="place-sheet__header">
      <div><h1 id="place-sheet-name">{place.name}</h1></div>
      <button ref={closeButton} className="place-sheet__close" type="button" onClick={onClose} aria-label="地点の詳細を閉じる">×</button>
    </header>
    {place.title && place.title !== place.name && <p className="place-sheet__title">{place.title}</p>}
    {(photos.length > 0 || place.explanation) && <details className="place-sheet__about">
      <summary>写真・場所の説明</summary>
      {photo && <img key={`${place.id}:${photo}`} className="place-sheet__photo" src={photo} alt={`${place.name}の登録写真`}
        onError={() => setFailedPhotos(previous => [...previous, photo])} />}
      {photoFailed && <p className="place-sheet__note">写真を表示できませんでした。</p>}
      {place.explanation && <p className="place-sheet__description">{place.explanation}</p>}
    </details>}
    <PlaceVisitHistory placeId={place.id} />
    <footer className="place-sheet__footer">
      {isLoggedIn ? <button type="button" className="place-sheet__manage" onClick={onManage}>
        {canEdit ? 'チェックイン・地点を編集' : 'チェックイン'}
      </button> : <p className="place-sheet__note">チェックインはログインして利用できます。</p>}
      <button type="button" className="place-sheet__back" onClick={onClose}>← 地図に戻る</button>
    </footer>
  </section>;
}
